export function bindKeys(
  onKey: (code: string, down: boolean) => void,
  onPause: () => void,
  onAction: () => void,
): () => void {
  const down = (e: KeyboardEvent) => {
    if (e.repeat && (e.code === 'Space' || e.code === 'Escape' || e.code === 'KeyP')) return;
    if (e.code === 'Space') {
      e.preventDefault();
      onAction();
      return;
    }
    if (e.code === 'Escape' || e.code === 'KeyP') {
      e.preventDefault();
      onPause();
      return;
    }
    onKey(e.code, true);
  };
  const up = (e: KeyboardEvent) => onKey(e.code, false);
  window.addEventListener('keydown', down);
  window.addEventListener('keyup', up);
  return () => {
    window.removeEventListener('keydown', down);
    window.removeEventListener('keyup', up);
  };
}
